export const TECHNICAL_CONDITION = [
    {key: "GOOD", name: "Яхши"},
    {key: "SATISFACTORY", name: "Қониқарли"},
    {key: "DISSATISFIED", name: "Қониқарсиз"},
    {key: "ACCIDENT_STATE", name: "Аварий холатида"},
    {key: "UNUSABLE", name: "Фойдаланишга яроқсиз"}
];
